<div class="dialog-overlay">
  <div class="dialog-container" [class]="'dialog-' + data.type">
    <div class="dialog-header">
      <div class="header-icon" [class]="'icon-' + data.type">
        <mat-icon>{{ getIcon() }}</mat-icon>
      </div>
      <button mat-icon-button class="close-button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body">
      <h2 class="dialog-title">{{ data.title }}</h2>
      <p class="dialog-message">
        {{ data.message }}
        <strong *ngIf="data.highlightText" class="dialog-highlight">{{ data.highlightText }}</strong>
        <ng-container *ngIf="data.highlightText">? This action cannot be undone.</ng-container>
      </p>
    </div>

    <div class="dialog-actions">
      <button
        mat-button
        class="btn-cancel"
        (click)="onCancel()">
        {{ data.cancelText || 'Cancel' }}
      </button>
      <button
        mat-raised-button
        class="btn-confirm"
        [class]="'btn-' + data.type"
        (click)="onConfirm()">
        {{ data.confirmText || 'Confirm' }}
      </button>
    </div>
  </div>
</div>
